import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormComponentComponent } from 'src/app/components/form-component/form-component.component';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-payment-proof',
  templateUrl: './payment-proof.page.html',
  styleUrls: ['./payment-proof.page.scss'],
})
export class PaymentProofPage implements OnInit {
  @ViewChild('formProof') formProof: FormComponentComponent;
  private _domainId = environment.domainId;
  public fieldsForm = undefined;
  public methods = [];
  public bannerRes = [];

  constructor(
    private httpSv: HttpService,
    private formSv: FormServices,
    private uiSv: UiServices,
    private trSv: TranslateService
  ) {}

  async ngOnInit() {
    const bannerRes = await this.httpSv.itemIndex(
      'paymentProof/view',
      this._domainId
    );
    this.bannerRes = bannerRes.data || [];
    const methods: any = await this.httpSv.itemIndex(
      'client/banks',
      this._domainId
    );
    this.methods = methods.data;

    const res = await this.formSv.getForm('paymentProof', this._domainId);
    this.fieldsForm = res;
  }

  async send(ev: FormData) {
    ev.append('domainId', this._domainId.toString());
    await this.uiSv.showLoading();
    await this.httpSv.itemAction(ev, 'paymentProof', 'store');
    await this.uiSv.loading.dismiss();
    const txt = this.trSv.instant('REPORTE_ENVIADO_CON_EXITO');
    this.formProof.resetForm();
    await this.uiSv.showToast(txt);
  }
}
